// extracted by mini-css-extract-plugin
export default {"container":"d1709v0IgAoDdxv0X_yn","answerOptionsInput":"fPs9EtJsP8LQ2eMAses2"};